import React from 'react';
import { HorizontalMenuItem } from 'types/model';
import { MenuClassName, ShadowBackgroundClassName } from './style';
import { Layout } from 'fronton-react';
import { MenuItem } from './menu-item';

export const LOCATOR_ID = 'header_fixed_horizontal_menu';

type HorizontalMenuProps = {
  list: Array<HorizontalMenuItem>;
};

export const HorizontalMenu = (props: HorizontalMenuProps) => {
  return (
    <>
      <Layout data-qa={LOCATOR_ID}>
        <div className={MenuClassName}>
          {props.list.map((item) => {
            return <MenuItem key={item.text} model={item} />;
          })}
        </div>
      </Layout>
      <div className={ShadowBackgroundClassName} />
    </>
  );
};
